import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ReservationRetailService } from '../../services';

@Component({
    selector: 'app-reservation-retail-cancel',
    templateUrl: './reservation-retail-cancel.component.html',
    styleUrls: ['./reservation-retail-cancel.component.css']
})
export class ReservationRetailCancelComponent implements OnInit {
    externalQrCode: string;
    qrCode: string;
    email: string;

    constructor(
        private route: ActivatedRoute,
        private reservationService: ReservationRetailService,
        private messageService: MessageService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(p => {
            this.externalQrCode = p.get('qrCode');
            this.qrCode = this.externalQrCode;
        });
    }

    cancelReservation(): void {
        this.reservationService.cancelReservation(this.qrCode).subscribe(
            () => {
                this.messageService.add({ severity: 'success', summary: 'Anulowano rezerwację', detail: '' });
                this.qrCode = '';
                this.externalQrCode = '';
            },
            (error) => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Błąd anulowania rezerwacji', detail: error.message });
            }
        );
    }
}
